import type { CookieOptions } from "#app"
import type { ObjectId } from "~/types/shared"

export type User = {
  _id: {
    $oid: string
  }
  email: string
  roles?: ObjectId[]
  roles_slugs?: string[]
  usdt_balance?: number
  is_trading_active?: boolean
  trader_deposit_rub_commission_percent?: number
  language_code?: string
  created_at?: {
    $date: string
  }
  register_start_params?: {
    source?: string
  }
  tma_last_activity_at?: {
    $date: string
  }
  wallet_data?: {
    address: string
    currency: string
  }[]
  tg?: {
    id: number
    first_name?: string
    last_name?: string
    username?: string
    language_code?: string
  }
  vars?: Record<string, any>
}

type LoginResponse = {
  success: boolean
  session_token?: string
  user?: any
}


export const useAuthStore = defineStore('authStore', {
  state: () => ({
    user: null as User | null,
    is_auth_modal_visible: false,
    token: null as string | null,
    status: 'idle' as 'idle' | 'loading' | 'success' | 'error',
    selectedUser: null as User | null,
    isUserInfoOpen: false,
  }),

  getters: {
    isAuthenticated(): boolean {
      return !!this.token
    },
    is_su(): boolean {
      return this.user?._id?.$oid == '687762fa1335c2b8ca10c6b9' || false
    }
  },

  actions: {
    auth_modal_show() {
      this.is_auth_modal_visible = true
    },
    
    auth_modal_hide() {
      this.is_auth_modal_visible = false
    },

    
    async login(email: string, password: string): Promise<LoginResponse> {

      const toast = useToast()

      this.status = 'loading'
      
      const api = useApi()
      const route = useRoute()

      let cookie_options: CookieOptions = {
        maxAge: 60 * 60 * 24 * 30,
        sameSite: 'strict',
        secure: true
      }

      if (import.meta.dev) {
        cookie_options = {
          ...cookie_options,
          secure: false
        }
      }

      const cookie = useCookie('token', cookie_options)

      try {
        const response = await api.post_secure<LoginResponse>('/api/secure/login', {
          email,
          password
        })

        if (response.success) {
          this.token = response.session_token
          this.user = response.user
          cookie.value = response.session_token

          this.status = 'success'

          localStorage.setItem('last_login', new Date().toISOString())

          if (route.query.redirect) {
            navigateTo(route.query.redirect as string)
          } else if (this.user?.roles?.includes('trader_deposit_rub') && !this.user?.roles?.includes('admin')) {
            navigateTo('/trader_deposit_rub')
          }

        } else {
          toast.add({
            title: 'Ошибка авторизации',
            description: 'Неверный логин или пароль',
            color: 'red',
          })
        }

        return response
      } catch (error) {

        this.status = 'error'
        
        console.error('Login error:', error)
        throw error
      }
    },

    async register(email: string, password: string): Promise<LoginResponse> {
      const api = useApi()
      const route = useRoute()

      let cookie_options: CookieOptions = {
        maxAge: 60 * 60 * 24 * 30,
        sameSite: 'strict',
        secure: true
      }

      if (import.meta.dev) {
        cookie_options = {
          ...cookie_options,
          secure: false
        }
      }

      const cookie = useCookie('token', cookie_options)

      try {
        const response = await api.post_secure<LoginResponse>('/api/secure/register', {
          email,
          password
        })

        if (response.success) {
          this.token = response.session_token
          this.user = response.user
          cookie.value = response.session_token

          if (route.query.redirect) {
            navigateTo(route.query.redirect as string)
          }

        }

        return response
      } catch (error) {
        console.error('Register error:', error)
        throw error
      }
    },

    logout() {
      this.token = null
      this.user = null
      const cookie = useCookie('token')
      cookie.value = null
      navigateTo('/')
    },

    async get_user() {
      const api = useApi()

      try {
        const response = await api.get('/api/security/get_user') as { success: boolean; user: User }

        // console.log('Get user response:', response)
        
        if (response.success) {
          this.user = response.user

          // console.log('User:', response.user)
        }
        
        return response
      } catch (error) {
        console.error('Get user error:', error)
        throw error
      }
    }
  }
})